import { useEffect } from 'react'

// Libs
import { useAppSelector, useAppDispatch } from '@/redux/hooks'
import { getUserMediaList } from '@/methods/media/getUserMediaList'
import { setMediaData, setHasAccess } from '@/redux/reducers/media'

// Constants

const useDevices = () => {
  const dispatch = useAppDispatch()

  const mediaData = useAppSelector((state) => state.media.mediaData)
  const currentVideoInputId = mediaData?.currentVideoInputId

  useEffect(() => {
    if (typeof window === 'undefined') return
    if (currentVideoInputId) return

    try {
      navigator.mediaDevices
        .getUserMedia({ video: true, audio: true })
        .then((stream) => {
          getUserMediaList().then((result) => dispatch(setMediaData(result)))

          dispatch(setHasAccess({ hasAccess: true }))

          stream.getTracks().forEach((track: any) => {
            track.stop()
          })
        })
        .catch((error) => {
          dispatch(setHasAccess({ hasAccess: false }))

          console.error('shop', 'error', error)
        })
    } catch (error) {
      console.log('shop', 'getUserMedia error', error)
    }
  }, [])
}

export default useDevices
